import { AppModule } from '@app/types';

export const FragmentsModule: AppModule = {
  id: 'fragments',
  title: 'Fragments',
  basePath: 'fragments',
};
